import React from 'react';
import { Box, BoxProps } from '@mui/material';

const Container: React.FC<BoxProps> = ({ children, ...rest }) => (
  <Box mx="auto" width="calc(100% - 96px)" {...rest}>
    {children}
  </Box>
);

export default Container;
